import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError, map, withLatestFrom } from 'rxjs/operators';

import * as fromStore from '../store';
import * as fromRoot from '../../store';
import { Observable, of } from 'rxjs';
import { SetTitle, SetTags } from '../../store';
import { StringUtility } from '@teamfoster/sdk/text-utility';
import { getSettings } from '../../settings/store';

@Injectable({ providedIn: 'root' })
export class ContentPageMetaGuard {
  private store = inject<Store<fromStore.ContentState>>(Store);


  canActivate(): Observable<boolean> {
    return this.checkStore().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  checkStore(): Observable<boolean> {
    return this.store.select(fromStore.getSelectedContentLoaded).pipe(
      withLatestFrom(
        this.store.select(getSettings),
        this.store.select(fromStore.getSelectedContent),
        this.store.select(fromRoot.getRouterState)
      ),
      filter(([loaded, settings, page, router]) => loaded! && page?.id === +router.state.params['pageId']),
      tap(([loaded, settings, page, router]) => {
        this.store.dispatch(SetTitle({ title: `${page.metaData.title} - ${settings!.homeMetaData.title}` }));
        this.store.dispatch(
          SetTags({
            properties: {
              'description': StringUtility.Truncate(StringUtility.StripHTML(page.metaData.description), 157, '...'),
              'og:image': `https:${page.metaData.imageUrl}`,
              'og:title': `${page.metaData.title} - ${settings?.homeMetaData.title}`,
              'og:description': StringUtility.Truncate(StringUtility.StripHTML(page.metaData.description), 157, '...'),
            },
          })
        );
      }),
      map(([loaded, settings, page, router]) => loaded! && page?.id === +router.state.params['pageId']),
      take(1)
    );
  }
}
